import { useEffect, useMemo } from "react";

import { useProjectActions, useProjectContext } from "@contexts/projects";

import ProjectionLoadState from "../../financialProjection/ProjectionLoadState";
import EapRuleRow from "./EapRuleRow";
import ServiceAccordion from "./ServiceAccordion";

const SubstepAccordion = ({ parent, months }) => {
  const {
    activeProject: { _id, substeps = {} },
    filterDates,
  } = useProjectContext();
  const { loadSubsteps } = useProjectActions();

  useEffect(() => {
    if (_id) loadSubsteps(parent);
  }, [_id, parent, filterDates]);

  const stepSubsteps = useMemo(() => substeps[parent], [substeps, parent]);

  return (
    <>
      <ProjectionLoadState
        level="substeps"
        parent={parent}
        isMissing={!stepSubsteps}
        onRetry={() => loadSubsteps(parent)}
      />
      {stepSubsteps?.map((item) => (
        <EapRuleRow
          key={item.wbs_code_id}
          item={item}
          type="substep"
          typeTitle="Subetapa"
          months={months}
          ChildAccordionComponent={ServiceAccordion}
        />
      ))}
    </>
  );
};

export default SubstepAccordion;
